export default "__VITE_ASSET__BJVuFHAZ__"